import * as T from 'three';
import {RoundedBoxGeometry} from 'three/addons/geometries/RoundedBoxGeometry.js';
// A small cake knife: a flat steel blade, edge down, with a pastel grip along
// its top. The group origin is the middle of the cutting edge.
export function makeKnifeTool(height){
  const group=new T.Group(),blade=height*.5,width=height*.46;
  const steel=new T.MeshPhysicalMaterial({color:'#efeaf8',metalness:.05,roughness:.26,clearcoat:.8,clearcoatRoughness:.12});
  const grip=new T.MeshPhysicalMaterial({color:'#f3c5d4',roughness:.42,clearcoat:.5,clearcoatRoughness:.25});
  const plate=new T.Mesh(new RoundedBoxGeometry(height*.022,blade,width,2,height*.009),steel);plate.position.y=blade/2;
  const handle=new T.Mesh(new RoundedBoxGeometry(height*.11,height*.12,width*1.04,4,height*.05),grip);handle.position.y=blade+height*.045;
  group.add(plate,handle);group.name='knife_tool';
  for(const mesh of group.children){mesh.userData.knifeTool=true;mesh.castShadow=true;}
  group.userData.dispose=()=>{for(const mesh of group.children){mesh.geometry.dispose();mesh.material.dispose();}};
  return group;
}
const smooth=x=>{x=Math.max(0,Math.min(1,x));return x*x*(3-2*x);};
const mix=(a,b,t)=>a.map((v,i)=>v+(b[i]-v)*smooth(t));
// Keyboard demo: from wherever the knife is, over the score, down through it, back up and home.
export function knifeDemoTarget(time,{start,home,seamX,top,height}){
  const above=[seamX,top+height*.1,0],through=[seamX,top-height*.66,0],lifted=[seamX,top+height*.16,0];
  if(time<.32)return mix(start,above,time/.32);
  if(time<.8)return mix(above,through,(time-.32)/.48);
  if(time<1.08)return mix(through,lifted,(time-.8)/.28);
  return mix(lifted,home,(time-1.08)/.36);
}
export const KNIFE_DEMO_SECONDS=1.44;
